
import { defineComponent, onActivated, onBeforeUnmount, onDeactivated, onMounted, nextTick, watch } from 'vue'
import resize from './mixins/resize'
import { init, EChartsOption } from 'echarts'
import * as echarts from 'echarts'
export default defineComponent({
  props: {
    chartData: {
      type: Object,
      default: {}
    },
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'lineChartsCompoents'
    },
    width: {
      type: String,
      default: '100%',
      required: true
    },
    height: {
      type: String,
      default: '193px',
      required: true
    }
  },
  setup(props) {
    watch(props, (newName, oldName) => {
      console.log(99999,props)
      initChart()
    });
    const {
      mounted,
      chart,
      beforeDestroy,
      activated,
      deactivated
    } = resize()
    const initChart = () => {
      const map = props.chartData;
      if( !Object.keys(map).length ){
        return false;
      }

      const barChart = init(document.getElementById(props.id) as HTMLDivElement)
      let xdata = [],seriesData = []
      for (let index = 0; index < map.data.length; index++) {
        xdata.push(map.data[index].x)
        seriesData.push(map.data[index].y)
        // seriesData.push(props.chartData[index].valuation)
      }
      barChart.setOption({
        legend: {
          // show: false,
          data: ['高估', 'Evaporation'],
          // icon: 'circle',
          // x: '0',
          // left: '0',
          // textStyle: {
          //   align: 'left', // 这个是可以左右调整的
          //   fontSize: 10// 字体大小
          //   // padding:[0,0,25,-45]//主要就是用这个，可以把文字上下调整
          //   // color: 'rgba(255,255,255,0.65)'//字体颜色
          // }
        },
        grid: {
          containLabel: true,
          bottom:10,
          top:10,
          left:0,
          right:0
        },
        tooltip: {
          show: true,
          trigger: 'axis', 
          // position:'inside',
          // padding:4,
          // textStyle:{
          //   color:'#999999',
          //   fontSize:'10',
          // },
          // // positio1n:function(point,params,dom,rect){
          // //   let x = 0
          // //   let y= 0
          // //   if(point[0]>210){
          // //     x = point[0] - 100
          // //   }else{
          // //     x = point[0] +10
          // //   }
          // //   if(point[1]>55){
          // //     y = point[1] - 60
          // //   }else{
          // //     y = point[1]
          // //   }
          // //   return [x,y]
          // // },
          // formatter:function(param:any){
          //  // 利用循环更改显示的内容
          //   let list = param.length
          //   let Oparam=param
          //   let txt =" "+ param[0].name+"\n"
          //   for (var i=0;i<list;i++){
          //    if(i==list-1){
          //     txt +=param[i].marker+ param[i].seriesName + ":" + param[i].data
          //    }else{
          //      txt +=param[i].marker+ param[i].seriesName + ":" + param[i].data + '\n'
          //    }
          //   }
          //   return txt
          // }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xdata,
          show:  false,
          axisLine:{
            lineStyle:{
              color: '#BFC0C4',
              width:1,
            }
          },
          // axisLabel:{
          //   // interval:Math.floor(list1.length/3),
          //   interval:2,
          //   formatter:function(val:any){      
          //     return ''
          //   },
          //   margin:20,
          //   textStyle:{
              
          //   }
          // }
        },
        yAxis: {
          x: 'center',
          type: 'value',
          splitLine: {
            lineStyle: {
              // type: 'dashed'
              color: '#e6e6e6',
              width:1,
            }
          },
          axisLabel : {
            textStyle: {
                color: '#86878B'
            }
          },
          // min:18,
          // max:38,
          // interval:2,
          // show: false
        },
        series: [{
          type: 'line',
          smooth: false,
          showSymbol:false,
          itemStyle:{
            normal:{
              lineStyle:{
                color:'#0285FA'
              },
            }
          },
          areaStyle:{
            normal: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                    offset: 0,
                    color: "#BCDEFD" // 0% 处的颜色
                  }, {
                    offset:  1,
                    color: "#F9FBFF" // 100% 处的颜色
                  }],
    
                  }
                }
          },
          markLine:{
            data: [{
              yAxis: map.max,
              lineStyle:{
                normal:{
                  type:'dashed',
                  color:'#951EFD',
                  width:1,
                }
              }
            },{
              yAxis: map.mid,
              lineStyle:{
                normal:{
                  type:'dashed',
                  color: '#D0031B',
                  width:1,
                }
              }
            },{
              yAxis: map.min,
              lineStyle:{
                normal:{
                  type:'dashed',
                  color: '#E9C036',
                  width:1,
                }
              }
            }],
            symbol:'none',
            silent: true,
            label:{
              show:false
            },
            
          },
          data:seriesData
        }]
      } as unknown as EChartsOption)
      chart.value = barChart
    }

    onMounted(() => {
      mounted()
      nextTick(() => {
        initChart()
      })
    })

    onBeforeUnmount(() => {
      beforeDestroy()
    })

    onActivated(() => {
      activated()
    })

    onDeactivated(() => {
      deactivated()
    })

    return {

    }
  }
})
